import React, { lazy, Suspense } from 'react';

import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';

import Loading from '../containers/Loading';
import NotFound from '../containers/NotFound';

import ROUTES from './routes';

const Layer = lazy(() => import('../containers/Layer'));
const Authentication = lazy(() => import('../containers/Authentication'));
const Documents = lazy(() => import('../containers/Documents'));
const Fields = lazy(() => import('../containers/Fields'));
const Finish = lazy(() => import('../containers/Finish'));
const Liveness = lazy(() => import('../containers/LivenessDetection'));

const Routes = () => (
  <Router>
    <Suspense fallback={<Loading />}>
      <Layer>
        <Switch>
          <Route
            exact
            path={ROUTES.AUTHENTICATION_ROUTE}
            component={Authentication}
          />
          <Route
            exact
            path={ROUTES.UPLOAD_DOCUMENTS_ROUTE}
            component={Documents}
          />
          <Route
            exact
            path={ROUTES.UPLOAD_FIELDS_ROUTE}
            component={Fields}
          />
          <Route
            exact
            path={ROUTES.FINISH_ROUTE}
            component={Finish}
          />
          <Route
            exact
            path={ROUTES.LIVENESS_ROUTE}
            component={Liveness}
          />
          <Route component={NotFound} />
        </Switch>
      </Layer>
    </Suspense>
  </Router>
);

export default Routes;
